<template>
  <div class="partners-module">
    <div class="item-container">
      <div class="item">
        <a target="_blank" href="https://filimo.com">
          <img src="~@/assets/img/partners/sp1.png" alt="" />
        </a>
      </div>
      <div class="item">
        <a target="_blank" href="https://aparat.com">
          <img src="~@/assets/img/partners/sp2.png" alt="" />
        </a>
      </div>
      <div class="item">
        <a target="_blank" href="https://www.jahannava.ir">
          <img src="~@/assets/img/partners/sp3.png" alt="" />
        </a>
      </div>
      <div class="item">
        <a target="_blank" href="https://kish.ir">
        <img src="~@/assets/img/partners/sp4.png" alt="" />
        </a>
      </div>
      <div class="item">
        <a target="_blank" href="https://kishhotelsassociation.com/">
          <img src="~@/assets/img/partners/sp5.png" alt="" />
        </a>
      </div>
      <div class="item">
        <a target="_blank" href="http://kishmall.com">
          <img src="~@/assets/img/partners/sp6.png" alt="" />
        </a>
      </div>

      <div class="item">
        <a target="_blank" href="https://webtab.org">
          <img src="~@/assets/img/partners/sp7.png" alt="" />
        </a>
      </div>
      <div class="item">
        <a target="_blank" href="https://www.firoozniacharity.ir">
          <img src="~@/assets/img/partners/sp8.png" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.partners-module {
  padding: 20px 0;

  .item-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item {
      width: 35px;
      height: 35px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
